import React from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { RedirectSingleton, RedirectType } from '@pkg/classes';
import { Web3AuthSteps } from '@pkg/components/Web3Auth';

import { W3aStandAloneFlow } from '@app/pages/w3a';
import { useCheckUserGlobalRedirects } from '@app/routes/hooks';
import { APP_ANONYMOUS_LANDING_PAGE } from '@app/routes/paths';
import { UserType, useUser } from '@app/store/zustand';
import { useAuthTokens } from '@app/store/zustand/auth/useAuthTokens';

export const ProtectedRoute = () => {
    const { isAuthenticated } = useAuthTokens();
    const { isLoading, type: accountType } = useUser();

    const redirectTo = useCheckUserGlobalRedirects();
    const { search, pathname } = useLocation();
    const hasPath = pathname?.length > 1;
    const fullPath = search ? `${pathname}${search}` : pathname;

    /*
     * When user is still loading, we don't want to redirect them or show
     * an empty page. This would be the best place to introduce a skeleton
     * loader if necessary.
     */
    if (isLoading) return;

    if ((!isAuthenticated || (isAuthenticated && accountType === UserType.Draft)) && hasPath) {
        RedirectSingleton.setRedirect(RedirectType.PostLogin, fullPath);
        return <Navigate to={APP_ANONYMOUS_LANDING_PAGE} replace />;
    }

    /*
     * Show email verification UI only if user is authenticated and not verified.
     * Do not show this screen for draft users
     */
    if (!isLoading && isAuthenticated && accountType === UserType.Registered) {
        return <W3aStandAloneFlow step={Web3AuthSteps.EmailActivation} />;
    }

    return redirectTo ? <Navigate to={redirectTo} replace /> : <Outlet />;
};
